import * as actions from "../../../actions/client/credit";

const initialState = {
  loading: false,
  errors: {}
};

const reducer = function(state = initialState, { type, payload }) {
  switch (type) {
    case actions.SET_VALUE: {
      return {
        ...state,
        ...payload
      };
    }
    case actions.CLEAR_VALUE: {
      return {
        ...state,
        ...initialState
      };
    }
    case actions.ADD_CLIENT_CREDIT: {
      return {
        ...state,
        loading: true
      };
    }
    case actions.ADD_CLIENT_CREDIT_FAILED: {
      return {
        ...state,
        loading: false
      };
    }
    case actions.ADD_CLIENT_CREDIT_SUCCESS: {
      return {
        ...state,
        ...initialState,
        loading: false
      };
    }
    default: {
      return state;
    }
  }
};

export default reducer;
